import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { Root, Handle } from './styled.js';
import { jsx } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function getRadii(size) {
  switch (size) {
    case 'sm':
      return 16;
    case 'md':
    default:
      return 22;
  }
}
/**
 * A control that allows the user to toggle between checked and not checked.
 * @see https://www.radix-ui.com/docs/primitives/components/switch
 */
function Switch(props) {
  var size = props.size,
    rest = __rest(props, ["size"]);
  var radii = getRadii(size);
  return /*#__PURE__*/jsx(Root, _extends({
    $radii: radii
  }, rest, {
    children: /*#__PURE__*/jsx(Handle, {
      $radii: radii
    })
  }));
}

export { Switch };
